import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import Button from '../Button';
import './style.scss';

// Interface voor de props voor type-veiligheid
interface VacancyDetailsCtaProps {
  whatsappLink?: string;
  onVacancyApply: () => void;
  onlyShowOn?: 'mobile' | 'desktop';
}

function VacancyDetailsCta({
  whatsappLink,
  onVacancyApply,
  onlyShowOn,
}: VacancyDetailsCtaProps) {
  const { t } = useTranslation();

  const containerClasses = classNames(
    'vacancy-details-cta',
    onlyShowOn && `vacancy-details-cta--${onlyShowOn}`,
  );

  return (
    <div className={containerClasses}>
      <Button onClick={onVacancyApply}>
        {t('apply_vacancy')}
      </Button>

      {whatsappLink && (
        <Button
          href={whatsappLink}
          title={t('whatsapp_link.long')}
          icon="whatsapp"
          type="secondary"
        >
          {t('whatsapp_link.short')}
        </Button>
      )}
    </div>
  );
}

export default VacancyDetailsCta;
